var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-private',{attrs:{"pageTitle":'Rewards',"showBackBtn":_vm.$route.name=='RewardsList'},on:{"back":_vm.handleBack}},[_c('div',{staticClass:"page"},[_c('transition',{attrs:{"name":"slide-on-left"}},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }